'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'thumbtack';
var width = 384;
var height = 512;
var aliases = [128204,128392,"thumb-tack"];
var unicode = 'f08d';
var svgPathData = ['M16.7 336l350.6 0c-4.5-51.6-30.6-101.2-69.1-134.5l-5.1-4.4-.4-6.7-11.6-174.5-178.1 0-11.6 174.5-.4 6.7-5.1 4.4C47.3 234.8 21.2 284.4 16.7 336z', 'M75.4 189.4C33.5 225.6 5.2 279.5 .6 336 .2 341.3 0 346.7 0 352l384 0c0-5.3-.2-10.7-.6-16-4.6-56.5-32.8-110.4-74.7-146.6L297.1 16 352 16 352 0 32 0 32 16 86.9 16 75.4 189.4zM103 16l178.1 0 11.6 174.5 .4 6.7 5.1 4.4c38.5 33.3 64.6 82.8 69.1 134.5L16.7 336c4.5-51.6 30.6-101.2 69.1-134.5l5.1-4.4 .4-6.7 11.6-174.5zm81 384l0 144 16 0 0-144-16 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faThumbtack = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;